/**
 * LoadingIndicator Component.
 */
import * as React from 'react';

import Lottie, { EventListener } from 'react-lottie';

import { animations, AnimationListType } from 'theme/animations';
import { Container } from 'theme/layout';

/**
 * Renders lottie animations.
 *
 * @param props - Render props
 */
export function Loader(props: Props) {
  const { animationType, loop, onAnimationFinish, size } = props;
  const animation = animations[animationType];
  const defaultOptions = {
    loop,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  const listeners: EventListener[] = [];

  if (onAnimationFinish) {
    listeners.push({
      eventName: 'complete',
      callback: onAnimationFinish,
    });
  }

  return (
    <Container width={size} height={size}>
      <Lottie eventListeners={listeners} options={defaultOptions} height={size} width={size} />
    </Container>
  );
}
Loader.defaultProps = {
  loop: true,
};

interface Props {
  /** Lottie animation source */
  animationType: AnimationListType;
  /** A boolean flag that sets the animation container to cover its container */
  fullScreen?: boolean;
  /** A boolean flag indicating whether or not the animation should loop. */
  loop?: boolean;
  /** A number between 0 and 1, or an Animated number between 0 and 1. */
  progress?: number;
  /** Animation item size */
  size?: number;
  /** A callback function which will be called when animation is finished. */
  onAnimationFinish?(): void;
}
